var map = {
	"./1c.svg": "1abe",
	"./application.svg": "c59b",
	"./auction.svg": "143b",
	"./diagnostic.svg": "671a",
	"./fair-new.svg": "be38",
	"./fair.svg": "e6f9",
	"./favorites.svg": "4de4",
	"./filter.svg": "9e5e",
	"./graph.svg": "88d0",
	"./lots.svg": "b1cc",
	"./manual.svg": "e30f",
	"./new.svg": "0be0",
	"./parameters.svg": "73ad",
	"./plus.svg": "3c73",
	"./setting.svg": "2c46",
	"./template.svg": "58b9",
	"./trade.svg": "39b9",
	"./user.svg": "208f",
	"./users.svg": "be59"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fc52";